// extracted by mini-css-extract-plugin
export default {"clientProfile":"ClientProfile_clientProfile__r6xBX","clientProfileMain":"ClientProfile_clientProfileMain__fK2Uf","menu":"ClientProfile_menu__VEjE+"};